import React, { useState, useEffect } from "react";
import "./Header.css";

import ThIcon from "../../pics/th_icon.png";
import EnIcon from "../../pics/en_icon.png";
import Logo from "../../pics/RIHES-Logo1.png";

const Header = () => {
  const [language, setLanguage] = useState("th");
  const [pages, setPages] = useState("HSRC");

  const allTranslations = {
    HSRC: {
      th: {
        title: "ศูนย์วิจัยวิทยาศาสตร์สุขภาพ",
        subtitle: "หัวหน้าศูนย์วิจัยวิทยาศาสตร์สุขภาพ"
      },
      en: {
        title: "Health Sciences Research Center (HSRC)",
        subtitle: "Head of the Health Sciences Research Center (HSRC)"
      }
    },
    SHSR: {
      th: {
        title: "สำนักวิชาการวิจัยวิทยาศาสตร์สุขภาพ",
        subtitle: "หัวหน้าสำนักวิชาการวิจัยวิทยาศาสตร์สุขภาพ"
      },
      en: {
        title: "School of Health Sciences Research (SHSR)",
        subtitle: "Head of School of Health Sciences Research (SHSR)"
      }
    },
    PROCRC: {
      th: {
        title: "ศูนย์วิจัยทางคลินิกและนวัตกรรมสุขภาพ",
        subtitle: "หัวหน้าศูนย์วิจัยทางคลินิกและนวัตกรรมสุขภาพ"
      },
      en: {
        title: "RIHES-Pro CRC (PROCRC)",
        subtitle: "Head of the RIHES-Pro CRC (PROCRC)"
      }
    }
  };

  useEffect(() => {
    // อ่าน query parameter pages จาก URL
    const params = new URLSearchParams(window.location.search);
    const pageParam = params.get("pages") || "HSRC";
    setPages(pageParam);

    // อ่าน language จาก localStorage
    const savedLang = localStorage.getItem("language") || "th";
    setLanguage(savedLang);
  }, []);

  const handleLanguageChange = lang => {
    setLanguage(lang);
    localStorage.setItem("language", lang);

    // เปลี่ยนหน้าโดยรักษา pages parameter
    const path =
      lang === "th"
        ? `/Research_th?pages=${pages}`
        : `/Research_en?pages=${pages}`;
    window.location.href = path;
  };

  const translations = allTranslations[pages];

  return (
    <header className="header-container">
      {/* Top section: Logo + Language */}
      <div className="header-top">
        <div
          className="header-logo"
          onClick={() =>
            (window.location.href = `/${language === "th"
              ? "Research_th"
              : "Research_en"}?pages=${pages}`)}
          style={{ cursor: "pointer" }}
        >
          <img src={Logo} alt="Logo" />
        </div>

        <div className="header-language">
          <span className="language-label">
            {language === "th" ? "ภาษา" : "Language"}
          </span>
          <button
            onClick={() => handleLanguageChange("th")}
            className={`lang-btn ${language === "th" ? "active" : "inactive"}`}
          >
            <img src={ThIcon} alt="ไทย" />
          </button>
          <button
            onClick={() => handleLanguageChange("en")}
            className={`lang-btn ${language === "en" ? "active" : "inactive"}`}
          >
            <img src={EnIcon} alt="English" />
          </button>
        </div>
      </div>

      {/* Bottom section: Title */}
      <div className="header-title">
        <h1>
          {translations[language].title}
        </h1>
        <p>
          {translations[language].subtitle}
        </p>
      </div>
    </header>
  );
};

export default Header;
